export const ATTENDANCES_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'dashboard',
  'reception',
  'professional',
  'field',
  'online',
  'panel',
  'case_tracking',
  'public_agent_module_permission',
  'group_module_permission',
  'review',
  'place',
  'role',
  'activity_type',
]
